import { render } from "./ButtonAction.vue?vue&type=template&id=581af93b&scoped=true&ts=true"
import script from "./ButtonAction.vue?vue&type=script&lang=ts"
export * from "./ButtonAction.vue?vue&type=script&lang=ts"

import "./ButtonAction.vue?vue&type=style&index=0&id=581af93b&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-581af93b"]])

export default __exports__